// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ey-0";